import React from 'react';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { servicePages } from '../../servicePagesData';

const footerLinks = [
	{ label: 'Home', to: '/' },
	{ label: 'About', to: '/about' },
	{ label: 'Services', to: '/services' },
	{ label: 'Blog', to: '/blog' },
	{ label: 'Contact', to: '/contact' },
];

const Footer = () => {
	return (
		<Box
			component="footer"
			sx={{
				pt: { xs: 8, md: 10 },
				pb: 5,
				mt: { xs: 6, md: 10 },
				borderTop: `1px solid ${alpha('#e2e8f0', 0.08)}`,
				background: 'linear-gradient(180deg, rgba(9,20,35,0.2) 0%, rgba(9,20,35,0.72) 100%)',
			}}
		>
			<Container maxWidth="xl">
				<Box
					sx={{
						p: { xs: 3, md: 4 },
						borderRadius: '28px',
						backgroundColor: alpha('#0f172a', 0.72),
						border: `1px solid ${alpha('#e2e8f0', 0.08)}`,
						mb: 5,
					}}
				>
					<Grid container spacing={4} alignItems="center">
						<Grid item xs={12} md={8}>
							<Typography variant="h3" sx={{ mb: 1.2 }}>
								Ready to make the product feel more mature?
							</Typography>
							<Typography variant="body2">
								We help teams modernize the systems behind their brand so the user experience feels cleaner, faster, and more dependable.
							</Typography>
						</Grid>
						<Grid item xs={12} md={4} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
							<Button component={Link} to="/contact" variant="contained">
								Start the Conversation
							</Button>
						</Grid>
					</Grid>
				</Box>

				<Grid container spacing={{ xs: 4, md: 6 }}>
					<Grid item xs={12} md={5}>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
							<Box
								sx={{
									width: 44,
									height: 44,
									borderRadius: '16px',
									display: 'grid',
									placeItems: 'center',
									background: 'linear-gradient(135deg, rgba(37,99,235,0.28) 0%, rgba(20,184,166,0.18) 100%)',
									border: `1px solid ${alpha('#e2e8f0', 0.1)}`,
								}}
							>
								<img src="/favicon.svg" alt="BrokenCosmos Labs logo" width="24" height="24" />
							</Box>
							<Typography variant="h6">BrokenCosmos Labs</Typography>
						</Box>
						<Typography variant="body2" sx={{ maxWidth: 420 }}>
							Professional software modernization, systems integration, and dependable DevOps support for teams that want a stronger technical foundation.
						</Typography>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<Typography variant="overline" sx={{ color: '#93c5fd', letterSpacing: '0.08em' }}>
							Navigation
						</Typography>
						<Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 1.2 }}>
							{footerLinks.map((item) => (
								<Typography
									key={item.label}
									component={Link}
									to={item.to}
									variant="body2"
									sx={{ color: 'text.secondary', '&:hover': { color: 'text.primary' } }}
								>
									{item.label}
								</Typography>
							))}
						</Box>
					</Grid>
					<Grid item xs={12} sm={6} md={4}>
						<Typography variant="overline" sx={{ color: '#99f6e4', letterSpacing: '0.08em' }}>
							Contact
						</Typography>
						<Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 1.2 }}>
							<Typography variant="body2" sx={{ color: 'text.primary' }}>
								earth@brokencosmos.com
							</Typography>
							<Typography variant="body2">Toronto area, Canada</Typography>
							<Typography variant="body2">Software systems, infrastructure, and user experience improvement</Typography>
						</Box>
					</Grid>
				</Grid>

				<Box sx={{ mt: 4 }}>
					<Typography variant="overline" sx={{ color: '#93c5fd', letterSpacing: '0.08em' }}>
						Core Services
					</Typography>
					<Box sx={{ mt: 1.5, display: 'flex', flexWrap: 'wrap', gap: 1.4 }}>
						{servicePages.map((service) => (
							<Typography
								key={service.key}
								component={Link}
								to={service.path}
								variant="body2"
								sx={{ color: 'text.secondary', '&:hover': { color: 'text.primary' } }}
							>
								{service.kicker}
							</Typography>
						))}
					</Box>
				</Box>

				<Box
					sx={{
						mt: 5,
						pt: 3,
						borderTop: `1px solid ${alpha('#e2e8f0', 0.08)}`,
						display: 'flex',
						flexDirection: { xs: 'column', sm: 'row' },
						justifyContent: 'space-between',
						gap: 1.5,
					}}
				>
					<Typography variant="body2">© {new Date().getFullYear()} BrokenCosmos Labs. All rights reserved.</Typography>
					<Typography variant="body2">Built to feel clear, modern, and dependable.</Typography>
				</Box>
			</Container>
		</Box>
	);
};

export default Footer;
